import React from 'react';
import { useHref, useLinkClickHandler, useNavigate, useLocation, Navigate } from 'react-router-dom'
import type { Location } from 'react-router-dom';

export { useNavigate } from 'react-router-dom';

export const OpenExternalLink = async (url: string) => { window.open(url, '_blank', 'noopener,noreferrer'); return true as const }

export const usePathname = () => {
  const { pathname } = useLocation();
  return pathname;
};

export const useLink = (...[to, handlerArgs]: Parameters<typeof useLinkClickHandler>) => {
  const handler = useLinkClickHandler(to, handlerArgs)
  return {
    accessibilityRole: 'link' as const,
    onClick: (...params) => {
      window.scrollTo(0, 0);
      handler.apply(undefined, params);
    },
  }
}

export const CustomRedirect: React.FC<{path: string}> = ({path}) => {
  return React.createElement(Navigate, {to: path});
  //React.createElement(React.Fragment, null);
}

export const useGoBackLink = () => {
  const navigate = useNavigate()

  return {
    onClick: () => navigate(-1), // Go back to the previous page in history
    accessibilityRole: 'link' as const,
  }
}

export const useParamLink = (path, params={}) => {
  const navigate = useNavigate()
  const handlePress = () => {
    window.scrollTo(0, 0);
    navigate(path,{state:params})
  }

  return {
    accessibilityRole: 'link' as const,
    onClick: handlePress,
  }
}

export const useSearchParams = () => {
  const location = useLocation()
  const params = location.search || {} as Location['search']
  return new URLSearchParams(params)
  //return params
}

export const useLocationHash = () => {
  const location = useLocation();
  return [location.hash, (newHash: string) => { window.location.hash = newHash; }] as const;
}
